import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap, catchError } from 'rxjs';
import { ErrorHandlerService } from 'src/app/share/services/error-handler.service';
import { environment } from 'src/environments/environment';
const apiurl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class PriceChangeDateService {

  constructor(private readonly http: HttpClient, private readonly errorHandler: ErrorHandlerService) { }

  createItem(data: any): Observable<any> {
    return this.http.post<any>(`${apiurl}/item/pricechangedate`, data).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/item/pricechangedate/get`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  updateItem(data: any): Observable<any> {
    return this.http.put<any>(`${apiurl}/item/pricechangedate/${data.id}`, data).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  deleteItem(data: any): Observable<any> {
    return this.http.delete<any>(`${apiurl}/item/pricechangedate/${data.deleted_id}`).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
}
